const PermissionGroupStyles = {
  gridContainer: {
    justifyContent: 'center',
    '@media (min-width: 768px)': {
      justifyContent: 'space-between',
    },
  },
  groupContainer: {
    border: '1px solid #d5d5d5',
    borderRadius: 8,
    padding: '0 16px',
    backgroundColor: 'white',
    height: 320,
    overflow: 'hidden',
    '@media (min-width: 768px)': {
      height: 550,
      marginBottom: 16,
    },
  },
  permListContainer: {
    overflow: 'hidden',
    overflowY: 'auto',
    maxHeight: '100%',
    margin: '0 -16px',
    '&.leftPermList': {
      height: 250,
      '@media (min-width: 768px)': {
        height: 550,
      },
    },
  },
  permList: {
    padding: 0,
    '& h6': {
      paddingLeft: 16,
    },
  },
  permItem: {
    padding: 0,
    transition: 'background-color .2s ease',
    '&:nth-child(even)': {
      backgroundColor: '#f6f6f6',
    },
    '&.selected': {
      backgroundColor: '#ABDDFA',
    },
    '&.disabled': {
      backgroundColor: '#eeeeee',
    },
  },
  permItemBtn: {
    padding: '12px 0',
    width: '100%',
    margin: 0,
    textTransform: 'capitalize',
    fontWeight: 300,
    fontSize: 14,
    color: '#000 !important',
    paddingLeft: 16,
    display: 'block',
    textAlign: 'left'
  },
  adItem: {
    fontSize: 12,
    fontWeight: "500",
    '& svg': {
      width: 14,
      height: 15,
      margin: 0,
      verticalAlign: 'sub',
    }
  },
  inputAdornmentIcon: {
    marginRight: 8,
  },
  actionBtn: {
    width: '100%',
    margin: '24px 0',
    '@media (min-width: 600px) and (max-width: 768px)': {
      '&>span>span': {
        display: 'none'
      }
    },

  },
  actionBtnIcon: {
    transform: 'rotate(90deg)',
    '@media (min-width: 600px)': {
      transform: 'rotate(0deg)',
    },
    '& + span': {
      '@media (min-width: 600px)': {
        display: 'none',
      },
    },
  },
  addedGroupsContainer: {
    marginBottom: 16,
  },
  groupHeader: {
    backgroundColor: '#d5d5d5',

    '& h6': {
      margin: 0,
      lineHeight: 2,
      paddingLeft: 16,
    },
  },
  selectuserContainer: {
    '@media (min-width: 768px)': {
      padding: '0 8px'
    },
  },
  listUserItem: {
    padding: 0
  },
  userBtn: {
    padding: 8,
    justifyContent: 'left',
    textTransform: 'inherit',
    textAlign: 'left',
    margin: 0,
  },
  selectUserList: {
    height: 300,
    overflowY: 'auto'
  },
  emptySpace: {
    height: 300,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 500,
    color: 'lightgray',
    '@media (min-width: 768px)': {
      height: 530,
    },
  },
  inputGroupContainer: {
    padding: '0 10px',
    display: 'flex',
    alignItems: 'center',
  },
};

export default PermissionGroupStyles;
